'use strict';

var d3 = require('d3');
var SimpleLine = function SimpleLine(d3Helper) {
  /**
   * @param xPropertyName - a property name used to find X value
   * @param yPropertyName - a property name used to find Y value
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName, yPropertyName) {
    var params, scales;
    var lineFunction = d3.svg.line().defined(function (d) {
      return d[yPropertyName] !== undefined && d.visible;
    }).x(function (d) {
      var rightShift = scales.xScale.rangeBand() / 2;
      return scales.xScale(d[xPropertyName]) + rightShift;
    }).y(function (d) {
      return scales.yScale(d[yPropertyName]);
    }).interpolate('linear');
    var line = function line(container) {
      var group = d3Helper.createGroupElement(container, 'group-simple-line');
      var line = group.selectAll('.simple-line').data([container.datum()]);
      line.enter().append('path').attr('class', 'simple-line');
      line.attr('d', lineFunction).attr({
        'stroke': 'black',
        'stroke-width': '2',
        'fill': 'none'
      });
    };
    line.params = function (value) {
      params = value;
      return line;
    };
    line.scales = function (value) {
      scales = value;
      return line;
    };
    return line;
  };
};
SimpleLine.$inject = ['d3Helper'];
module.exports = SimpleLine;